"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformToMap = exports.toCamelCase = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * Transform snake_case string to camelCase
 *
 * @example
 * toCamelCase('gift_instant_options') //=> 'giftInstantOptions'
 *
 * @param {string} string - String that should be transformed.
 * @returns {String} - Transformed string.
 */
var toCamelCase = function toCamelCase(value) {
  return value.replace(/_+(\w)/g, function (_, ch) {
    return typeof ch === 'string' && ch.length === 1 ? ch.toUpperCase() : ch;
  });
};
/**
 * Transform features array to key-value map.
 *
 * @example
 * transformToMap([
 *  { name: 'gift_create', enabled: true },
 *  { name: 'gift_instant_options', enabled: false },
 * ]) // => { giftCreate: true, giftInstantOptions: false };
 *
 * @param {{ name: string, enabled: boolean }} featuresList - Array of features.
 * @returns {Object.<string, boolean>} - Key is feature name and value is his status.
 */


exports.toCamelCase = toCamelCase;

var transformToMap = function transformToMap(featuresList) {
  return featuresList.reduce(function (map, _ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return _objectSpread(_objectSpread({}, map), {}, {
      [toCamelCase(name)]: enabled
    });
  }, {});
};

exports.transformToMap = transformToMap;